import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { endOfApiScale, startOfApiScale } from '@library/store/measures/measures';
import { EnumApiScales, EnumScales, TimeRange } from '@library/store/measures/measures.interface';
import * as moment from 'moment-timezone';
import { Subscription, firstValueFrom } from 'rxjs';
import { SidebarControlModeService } from '../../../../sidebar-control-mode.service';

@Component({
  selector: 'app-home-mode-control-date-selector',
  templateUrl: './home-mode-control-date-selector.component.html',
  styleUrls: ['./home-mode-control-date-selector.component.scss'],
})
export class HomeModeControlDateSelectorComponent {

  errors$ = this.controlModeService.dateErrors$;

  selectedEndDate$ = this.controlModeService.selectedEndDate$;

  selectedEndDate: moment.Moment; // needed for validator that cannot be asynchronous.

  form: FormGroup = new FormGroup({
    endDateTime: new FormControl( (moment().hour() + 1)* 60, [Validators.required, this.minimumTimeToday()])
  });

  subscriptions = new Subscription();
  today: Date;

  scale = EnumScales.DAY;
  timeRange =  {
    dateBegin: null,
    dateEnd: null
  };

  constructor(
    private controlModeService: SidebarControlModeService,
    private homesFacade: HomesFacade,
  ) {
  }

  async ngOnInit() {
    this.subscriptions.add(this.selectedEndDate$.subscribe(endDate => {
      this.selectedEndDate = endDate;
    }));

    this.subscriptions.add( this.form.valueChanges.subscribe(value => {
      this.controlModeService.selectedEndTime$.next(value.endDateTime);
    }));

    const endDate = await firstValueFrom(this.homesFacade.currentModeEndTime$);

    // if end date not set, put default
    this.today = new Date();

    if (endDate) {
      const momentEndDate = moment( endDate * 1000);
      this.controlModeService.selectedEndDate$.next(momentEndDate);
      this.form.setValue({endDateTime: momentEndDate.hour() * 60 +  momentEndDate.minute()});
    }
    else {
      this.controlModeService.selectedEndDate$.next( moment(this.today));
      this.controlModeService.selectedEndTime$.next((moment().hour() + 1)* 60);
    }

    // initialize date picker
    const date = await firstValueFrom(this.controlModeService.selectedEndDate$);
    this.timeRange = {dateBegin: startOfApiScale(date, EnumApiScales.FIVE_MINUTES), dateEnd: endOfApiScale(moment(), EnumApiScales.FIVE_MINUTES)};
    this.selectDate(this.timeRange);
  }

  endDateToDayDate(selectedEndDate: moment.Moment) {
    return selectedEndDate?.format('ddd, ll');
  }

  selectDate(date: TimeRange) {
    this.controlModeService.selectedEndDate$.next(date.dateBegin);
    this.validateTime(this.form.controls.endDateTime);
  }

  minimumTimeToday(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return this.validateTime(control);
    };
  }

  validateTime(control: AbstractControl) {
    // if the date is today, cannot set time inferior at now
    if (this.selectedEndDate?.isSame(this.today, "day")) {
      if (control.value < (moment(this.today).hour() * 60 + moment(this.today).minute())) {
        this.controlModeService.dateErrors$.next({forbiddenHour: {value: control.value}});
        return  {forbiddenHour: {value: control.value}};
      }
      else {
        this.controlModeService.dateErrors$.next(null);
        return null;
      }
    }
    else {
      this.controlModeService.dateErrors$.next(null);
      return null;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}